<div class="settlement-template-view-container" fxFlex="100" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row" fxLayoutGap="15px"  fxLayoutAlign="space-between center">
    <div fxLayout="row" fxLayoutGap="15px">
      <button  *ngIf="!settlementTemplate.used" (click)="modify()" [disabled]="!(userPermissions | async).settlement.write || settlementTemplate.used" mat-stroked-button color="primary"><mat-icon>create</mat-icon> <span> Edytuj</span></button>
      <button  *ngIf="!settlementTemplate.used" (click)="delete()" [disabled]="!(userPermissions | async).settlement.delete || settlementTemplate.used" mat-stroked-button color="warn"><mat-icon>delete</mat-icon> <span> Usuń</span></button>
      <button  (click)="sendMail()"  mat-stroked-button color="primary"><mat-icon>send</mat-icon> <span> Wyślij szablon</span></button>
    </div>
    <button  *ngIf="!settlementTemplate.used" (click)="copyMessage(settlementTemplate.uuid)"  mat-icon-button color="primary" matTooltip="{{settlementTemplate.uuid}}"><mat-icon class="mat-icon-gray">info</mat-icon></button>
  </div>
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card fxLayout="column" fxFlex="100"  [ngClass]="settlementTemplate.used ? 'settlement-used ': '' ">
        <div *ngIf="settlementTemplate.used"fxLayout="row" fxFlex="100" fxLayoutGap="15px"  fxLayoutAlign="space-between center">
          <h3 >Szablon wysłany</h3>
          <button (click)="copyMessage(settlementTemplate.uuid)"  mat-icon-button color="primary" matTooltip="{{settlementTemplate.uuid}}"><mat-icon class="mat-icon-gray">info</mat-icon></button>
        </div>

        <div fxLayout="row" fxFlex="100" fxLayoutGap="15px" fxLayoutAlign="center center">
          <div fxFlex="20" >
            <app-detail fxFlex="100" header="Miesiąc rozliczeniowy" [value]="settlementTemplate.billingMonth"></app-detail>
          </div>
          <div  fxFlex="20" >
            <app-detail fxFlex="100" header="Data dodania" [value]="settlementTemplate.createdAt | date: 'y-MM-dd | HH:mm'"></app-detail>
          </div>
          <div  fxFlex="20" >
            <app-detail fxFlex="100" header="Firma" [value]="settlementTemplate.company?.name"></app-detail>

          </div>
          <div fxFlex="20">
            <app-detail fxFlex="100" header="Rodzaj rozliczenia" [value]="settlementTemplate.typeOfSettlement?.name"></app-detail>
          </div>
          <div fxFlex="20" >
          </div>
        </div>
        <div fxLayout="column" fxFlex="100" fxLayoutGap="15px" >
          <h3>Szablon</h3>
          <div [innerHTML]="settlementTemplate.content"></div>
        </div>
        <div fxLayout="column" fxFlex="100" fxLayoutGap="15px" >
          <hr>
          <h3>Zmienne wykorzystane w szablonie</h3>
          <div class="gridTable">
            <div>{{tempDefault}}</div>
            <div>Dowolna treść</div>
            <div></div>
          </div>
          <div class="gridTable">
            <div>{{tempMC}}</div>
            <div>Miesiąc rozliczeniowy</div>
            <div>{{settlementTemplate.billingMonth | date: ('y/MM')}}</div>
          </div>
          <div class="gridTable">
            <div>{{tempInitialBalance}}</div>
            <div>Kwota salda do wypłaty</div>
            <div></div>
          </div>
          <div class="gridTable">
            <div>{{tempAmount}}</div>
            <div>Kwota rozliczenia z danego miesiąca rozliczeniowego per Partner</div>
            <div></div>
          </div>
          <div class="gridTable" *ngIf="settlementTemplate.contentCommissionLess">
            <div>{{tempCommissionLess}}</div>
            <div>Treść maila dla kwota rozliczenia mniejszej od zera ( < 0.00 )</div>
            <div [innerHTML]="settlementTemplate.contentCommissionLess"></div>
          </div>
          <div class="gridTable" *ngIf="settlementTemplate.contentCommissionZero">
            <div>{{tempCommissionZero}}</div>
            <div>Treść maila dla kwoty rozliczenia równej zero ( = 0.00 )</div>
            <div [innerHTML]="settlementTemplate.contentCommissionZero"></div>
          </div>
          <div class="gridTable" *ngIf="settlementTemplate.contentCommissionHigher">
            <div>{{tempCommissionHigher}}</div>
            <div>Treść maila dla kwota rozliczenia większa od zera ( > 0.00 )</div>
            <div [innerHTML]="settlementTemplate.contentCommissionHigher"></div>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>
